import styled from 'styled-components';
import { spacing, colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { SecondaryPageHeader } from 'ui/pageHeader';
import { Tag, TAG_SIZES } from 'ui/tags';
import { SENDING_PLATFORMS_PAGE_TEXT, SendingPlatform } from '../../constants';
import { useMetadata } from '../../hooks';

export const HeaderContent = styled.div`
  display: grid;
  column-gap: ${spacing.half};
  grid-template-areas: 'logo name' 'logo tag';
  grid-template-columns: ${pxToRem(64)} 1fr;
  grid-template-rows: 1fr 1fr;
`;

export const LogoContainer = styled.div`
  align-items: center;
  background-color: ${colors.white};
  border: solid 1px ${colors.grey15};
  border-radius: ${pxToRem(4)};
  display: flex;
  grid-area: logo;
  height: ${pxToRem(64)};
  justify-content: center;
  width: ${pxToRem(64)};

  & img {
    width: 100%;
    padding: ${spacing.eighth};
  }
`;

export const CategoryTag = styled(Tag)`
  grid-area: tag;
  justify-self: start;
  margin: 0;
  padding-left: ${spacing.half};
  padding-right: ${spacing.half};
`;

export const PageHeader = ({ sendingPlatform }: { sendingPlatform: SendingPlatform }) => {
  const { name, category, logoSvg: Logo } = useMetadata(sendingPlatform);

  return (
    <SecondaryPageHeader
      breadcrumb={{
        content: 'See all Sending Platforms',
        href: '/settings/sendingPlatforms',
      }}
      data-test="sending-platforms-details-page-header"
      documentTitle={`${name} | ${SENDING_PLATFORMS_PAGE_TEXT.PAGE_HEADER}`}
    >
      <HeaderContent>
        <LogoContainer>
          <Logo height={48} width={48} />
        </LogoContainer>
        {name}
        <CategoryTag size={TAG_SIZES.LARGE}>{category}</CategoryTag>
      </HeaderContent>
    </SecondaryPageHeader>
  );
};
